export default {"src":"/_next/static/media/XIcon.2ece0717.svg","height":463,"width":512,"blurWidth":0,"blurHeight":0};